import { DailyVideo, useParticipantIds } from "@daily-co/daily-react";
import { useError } from "../providers/ErrorProvider";
import { useAgent } from "../providers/AgentProvider";

export default function DailyPlayer() {
  const remoteParticipantIds = useParticipantIds({ filter: "remote" });
  const { timeMsg } = useError();
  const { agentData } = useAgent();

  if (remoteParticipantIds.length === 0) {
    return null;
  }

  const remoteSessionId = remoteParticipantIds[0];
  const imgUrl = agentData?.image_url;

  return (
    <div className="h-full rounded-lg relative">
      {/* Image underlay - always displayed underneath the video */}
      {imgUrl && (
        <div
          className="absolute inset-0 bg-cover bg-center rounded-lg"
          style={{
            backgroundImage: `url(${imgUrl})`,
          }}
        />
      )}
      <DailyVideo
        sessionId={remoteSessionId}
        type="video"
        style={{ objectFit: "cover", width: "100%", height: "100%", position: "relative"}}
      />
      {/* Time message banner */}
      {timeMsg && (
        <div className="absolute top-2 left-2">
          <div className="bg-red-600/50 backdrop-blur-xl rounded-3xl py-2 px-4 w-fit shadow-inset-white-10">
            <p className="text-white text-lg font-semibold text-center">
              {timeMsg}
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
